
import './index.less'
import React from 'react'
const te = ['flex-start', 'center', 'flex-end']
console.log(React)
export default function ConversionOfficial(props) {
  return (<div className={`conversionOfficial ${props.selectItem ? props.selectItem.id === props.compIfon.id ? 'active' : '' : ''}`}
  >
    <div className='conversionOfficial_seizeASeat' style={{
      paddingTop: props.ifon.paddingTop,
      paddingBottom: props.ifon.paddingBottom,
      paddingLeft: props.ifon.paddingLeft,
      paddingRight: props.ifon.paddingRight,
      justifyContent: te[props.ifon.layout]
    }}>
      <button className='seizeASeat_button' style={{
        fontSize: props.ifon.fontSize,
        color: props.ifon.color,
        backgroundColor: props.ifon.colorBack,
        width: props.ifon.width + '%',
        height: props.ifon.height,
        borderRadius: props.ifon.fillet
      }}>{ props.ifon.text ? props.ifon.text : '继续阅读下一章'}</button>
    </div>
  </div>)
}
